// VehicleDropdown.jsx
import React, { useState, useEffect, useMemo } from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useClientInfo, axiosInstance } from "../utils/commonImports";


const VehicleDropdown = ({ vehicleId, clientId, onVehicleChange, checkVehicleDocumentsExpiry = false, }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // ============================
  // Fetch Vehicles
  // ============================
  useEffect(() => {
    if (!clientId) return;

    setLoading(true);
    axiosInstance
      .get(`/api/vehicles?client_id=${clientId}`)
      .then((res) => {
        setOptions(res.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [clientId]);

  // ============================
  // Find selected vehicle object
  // ============================
  const selectedVehicle = useMemo(() => {
    if (!vehicleId || options.length === 0) return null;

    return (
      options.find(
        (v) => Number(v.vehicle_id) === Number(vehicleId)
      ) || null
    );
  }, [vehicleId, options]);

  console.log("VehicleDropdown:", {
    vehicleId,
    selectedVehicle,
    optionsCount: options.length,
  });

  return (
    <Autocomplete
      options={options}
      loading={loading}
      value={selectedVehicle}
      fullWidth

      isOptionEqualToValue={(option, value) =>
        Number(option.vehicle_id) === Number(value.vehicle_id)
      }

      getOptionLabel={(option) =>
        option?.vehicle_number || ""
      }

      onChange={(event, newValue) => {
        console.log("VehicleDropdown selected value:", newValue);

        if (newValue) {
          onVehicleChange({
            vehicle_id: newValue.vehicle_id,
            vehicle_number: newValue.vehicle_number,
            vehicle_driver_id: newValue.vehicle_driver_id || "",
            vehicle_driver_name: newValue.vehicle_driver_name || "",
            vehicle_driver_mobile_no:
              newValue.vehicle_driver_mobile_no || "",
          });
        } else {
          onVehicleChange({
            vehicle_id: null,
            vehicle_number: "",
            vehicle_driver_id: "",
            vehicle_driver_name: "",
            vehicle_driver_mobile_no: "",
          });
        }
      }}

     renderOption={(props, option) => (
  <li
    {...props}
    key={option.vehicle_id}
    style={{
      display: "block",       // ⭐ important
      lineHeight: 1.3,
      paddingTop: 6,
      paddingBottom: 6,
    }}
  >
    <Typography
      component="div"          // ⭐ force block
      variant="body2"
      fontWeight="500"
    >
      {option.vehicle_number}
    </Typography>

    <Typography
      component="div"          // ⭐ force block
      variant="caption"
      sx={{ fontStyle: "italic", color: "text.secondary" }}
    >
      {option.vehicle_type_name},{" "}
      {option.vehicle_driver_name},{" "}
      {option.vehicle_driver_mobile_no}
    </Typography>
  </li>
)}

      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label="Vehicle Number"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && (
                  <CircularProgress color="inherit" size={18} />
                )}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default VehicleDropdown;
